import React from 'react';

import Hero from './components/Hero';
import ContactIntro from './components/ContactIntro';


export default class extends React.Component {

  render() {
    document.title = "Portfolio - Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";
    return (
      <div>

        <Hero
          h1split1="Geen beloftes. "
          h1split2="Bewijs."
          h2 = "Een inkijk in het werk waarmee ik de positionering van mijn klanten versterk op LinkedIn."
        />

        <div className="full big black">
          <div className="wrap content-block">
            <h2 style={{marginBottom:"1em"}}>Voor & Na: Van ruis naar autoriteit</h2>
            <h3 style={{marginTop:"0", textAlign:"center"}}>Voorbeelden van hoe kleine strategische ingrepen het verschil maken tussen zichtbaar zijn en serieus genomen worden.</h3>

            <h4 style={{textAlign:"center"}}>Post 1: Executive Rolaankondiging</h4>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Origineel</h3>
                <p style={{marginBottom:"1em"}}>Honoured and pleased to have started this week as CTO/CIO and member of the DT.<br/><br/>I received a very warm welcome from the team and want to thank everyone involved for the smooth transition after my predecessor.<br/><br/>Thanks to Johanna, Peter, Tim, Sarah, and Wim.<br/><br/>Big shoes to fill <span role="img" aria-label="wink emoji">😉</span>, but looking forward to the journey ahead.</p>
              </div>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Ghostin Style</h3>
                <p style={{marginBottom:"1em"}}>This week I stepped into my new role as CTO/CIO.<br/><br/>Not because the timing was comfortable.<br/>But because the responsibility was clear.<br/><br/>The welcome from the team was warm, and the expectations even warmer.<br/><br/>Taking over from a respected predecessor always comes with pressure.<br/>That’s exactly how it should be.<br/><br/>Now the real work begins.</p>
              </div>
            </div>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black" style={{paddingBottom:"1em"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Strategische Analyse</h3>

                <p style={{fontWeight:"bold"}}>1. Van aankondiging naar positioneringsmoment</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: klant wordt meer gezien als senioriteit</p>

                <p style={{fontWeight:"bold"}}>2. Van passieve toon naar besluitvaardige leiderschapsstem</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterkere executive aanwezigheid</p>

                <p style={{fontWeight:"bold"}}>3. Van interne focus naar externe leesbaarheid</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer herkenbaarheid buiten de directe kring</p>

                <p style={{fontWeight:"bold"}}>4. Van beleefdheid naar gecontroleerde spanning</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer stopkracht in de tijdlijn</p>

                <p style={{fontWeight:"bold"}}>5. Van knipoog naar executive zwaarte</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer autoriteit, minder verontschuldiging</p>

              </div>
            </div>

            <h4 style={{textAlign:"center"}}>Post 2: Netwerkevent</h4>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Origineel</h3>
                <p style={{marginBottom:"1em"}}>Such an inspiring #DiversityInclusion event!<br/><br/>Great to see the organization leading by example. Thanks to the speakers (Anna and Lente) for the excellent overview of all the impressive initiatives, and to the co-host Aadhya for the great collaboration.</p>
              </div>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Ghostin Style</h3>
                <p style={{marginBottom:"1em"}}>Many organizations talk about #DiversityInclusion.<br/><br/>Far fewer actually show it.<br/><br/>At a recent event, one thing stood out:<br/>not more policies, but visible ownership.<br/><br/>Initiatives only matter when people are willing to carry them in practice.<br/><br/>That’s where real inclusion begins.</p>
              </div>
            </div>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black" style={{paddingBottom:"1em"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Strategische Analyse</h3>

                <p style={{fontWeight:"bold"}}>1. Van compliment naar inhoudelijk standpunt</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer thought leadership</p>

                <p style={{fontWeight:"bold"}}>2. Van namedropping naar universele relevantie</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: groter bereikpotentieel</p>

                <p style={{fontWeight:"bold"}}>3. Van enthousiasme naar betekenis</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer gewicht en geloofwaardigheid</p>

                <p style={{fontWeight:"bold"}}>4. Van event-samenvatting naar patroonherkenning</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer intellectuele positie</p>

                <p style={{fontWeight:"bold"}}>5. Van veilige toon naar rustige scherpte</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer executive aanwezigheid</p>

              </div>
            </div>

            <h4 style={{textAlign:"center"}}>Post 3: Typische update</h4>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Origineel</h3>
                <p style={{marginBottom:"1em"}}>Met een ministerie als launching customer inmiddels vele AI use-cases in scope die organisatiebreed gedeeld kunnen worden <span role="img" aria-label="fire emoji">🔥</span></p>
              </div>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Ghostin Style</h3>
                <p style={{marginBottom:"1em"}}>AI-pilots zijn er inmiddels genoeg.<br/><br/>Wat zeldzamer is: use-cases die opschalen.<br/><br/>Met een launching customer werken we nu aan meerdere AI-toepassingen die organisatiebreed inzetbaar zijn.</p>
              </div>
            </div>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black" style={{paddingBottom:"1em"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Strategische Analyse</h3>
                <p style={{fontWeight:"bold"}}>1. Van projectupdate naar strategisch perspectief</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer strategisch gewicht</p>

                <p style={{fontWeight:"bold"}}>2. Van jargon naar heldere formulering</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: betere leesbaarheid op LinkedIn</p>

                <p style={{fontWeight:"bold"}}>3. Van losse mededeling naar spanningshaak</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer stopkracht in de feed</p>

                <p style={{fontWeight:"bold"}}>4. Van intern project naar bredere relevantie</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer herkenning bij leiders en organisaties</p>

                <p style={{fontWeight:"bold"}}>5. Van hype naar rustige autoriteit</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterkere executive uitstraling</p>

              </div>
            </div>

            <h4 style={{textAlign:"center"}}>Post 4: Emotionele opmerking bij een repost</h4>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Origineel</h3>
                <p style={{marginBottom:"1em"}}>Wat mij hier persoonlijk echt raakt, is dat een vd dames op de vraag:<br/>"Word je wel eens geholpen door mannen, als er iets vervelends op straat gebeurt?"<br/>antwoord:<br/>"Nee, maar wel door andere vrouwen."<br/><br/>Ik herken dat. In mezelf en ook de solidariteit onderling bij vrouwen.<br/><br/>Ik vind dat ontroerend en verdrietig. Dus mannen, komop, laat je horen.</p>
              </div>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Ghostin Style</h3>
                <p style={{marginBottom:"1em"}}>In dit fragment zegt een vrouw iets dat bleef hangen:<br/><br/>Op de vraag of mannen haar helpen wanneer er iets vervelends op straat gebeurt, antwoordt ze:<br/><br/>"Nee. Alleen andere vrouwen."<br/><br/>Dat raakt me.<br/><br/>Omdat veel vrouwen precies weten wat hiermee bedoeld wordt.<br/><br/>Solidariteit tussen vrouwen is vaak vanzelfsprekend.<br/>Maar steun van mannen zou dat ook moeten zijn.<br/><br/>Dus mannen: laat je horen wanneer het nodig is.</p>
              </div>
            </div>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black" style={{paddingBottom:"1em"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Strategische Analyse</h3>
                <p style={{fontWeight:"bold"}}>1. Van emotionele reactie naar gestructureerd verhaal</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer impact en duidelijkheid</p>

                <p style={{fontWeight:"bold"}}>2. Van persoonlijke beleving naar gedeelde ervaring</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: grotere betrokkenheid van lezers</p>

                <p style={{fontWeight:"bold"}}>3. Van rommelige formulering naar helder ritme</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: betere leesbaarheid in de LinkedIn-tijdlijn</p>

                <p style={{fontWeight:"bold"}}>4. Van losse emotie naar duidelijke boodschap</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterkere afsluiting</p>

                <p style={{fontWeight:"bold"}}>5. Van spontane reactie naar doordachte positionering</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer overtuigingskracht zonder de menselijke toon te verliezen</p>

              </div>
            </div>

            <h2 style={{marginBottom:"1em", marginTop:"3em"}}>Voorbeelden: Autoriteit in de praktijk</h2>
            <h3 style={{marginTop:"0", textAlign:"center"}}>Een selectie van posts die laten zien hoe mijn klanten hun positie zichtbaar maken op LinkedIn.</h3>

            <h4 style={{textAlign:"center"}}>Post 1: Tech CEO die opvallend tegenstrijdig is.</h4>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Ghostin Style</h3>
                <p style={{marginBottom:"1em"}}>
                  Het probleem met product-market fit is dat iedereen erover praat alsof het een eindpunt is.
                  <br/><br/>
                  Alsof je het bereikt..<br/>
                  en vanaf daar groeit alles vanzelf.
                  <br/><br/>
                  In de praktijk werkt het zelden zo.
                  <br/><br/>
                  Product-market fit is geen moment.<br/>
                  Het is een bewegend doel.
                  <br/><br/>
                  Markten veranderen.<br/>
                  Klanten veranderen.<br/>
                  Concurrenten veranderen.
                  <br/><br/>
                  En zodra je organisatie groeit, verandert ook je eigen product.
                  <br/><br/>
                  Wat gisteren perfect aansloot, kan morgen alweer tegengas opleveren.
                  <br/><br/>
                  Daarom zijn we intern gestopt met praten over product-market fit alsof het iets is dat je "haalt".
                  <br/><br/>
                  Voor ons is het eerder een continu proces van drie vragen:
                  <br/><br/>
                  - Waar zit vandaag de meeste frictie voor de klant?<br/>
                  - Welke aannames over ons product kloppen inmiddels niet meer?<br/>
                  - Wat zou er gebeuren als we het opnieuw moesten bouwen?
                  <br/><br/>
                  Niet comfortabel.<br/>
                  Wel noodzakelijk.
                  <br/><br/>
                  Want bedrijven verliezen hun voorsprong zelden omdat hun product stopt met werken.
                  <br/><br/>
                  Ze verliezen hem omdat ze blijven optimaliseren voor een markt die inmiddels veranderd is.
                </p>
              </div>
            </div>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black" style={{paddingBottom:"1em"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Strategische Analyse</h3>

                <p style={{fontWeight:"bold"}}>1. Van startup-buzzword naar kritisch perspectief</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterker thought leadership</p>

                <p style={{fontWeight:"bold"}}>2. Geen succesverhaal, maar leiderschapsreflectie</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer geloofwaardigheid</p>

                <p style={{fontWeight:"bold"}}>3. Van abstract concept naar praktisch denkmodel</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer intellectueel gewicht</p>

                <p style={{fontWeight:"bold"}}>4. Geen lineaire groei, maar realistische complexiteit</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer volwassen leiderschapsperspectief</p>

                <p style={{fontWeight:"bold"}}>5. Geen marketingtoon, maar rustige autoriteit</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterkere executive presence</p>

              </div>
            </div>

            <h4 style={{textAlign:"center"}}>Post 2: Peter die praat over zijn LinkedIn Framework.</h4>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Ghostin Style</h3>
                <p style={{marginBottom:"1em"}}>
                  Je kunt elke week posten op LinkedIn..<br/>
                  en toch geen autoriteit opbouwen.
                  <br/><br/>
                  Veel professionals verwarren drie dingen met elkaar:
                  <br/><br/>
                  - zichtbaarheid<br/>
                  - autoriteit<br/>
                  - positionering
                  <br/><br/>
                  Terwijl het drie compleet verschillende lagen zijn.
                  <br/><br/>
                  Daarom werk ik met wat ik het ZAP Framework noem.
                  <br/><br/>
                  <b>Zichtbaarheid</b><br/>
                  Mensen moeten je eerst zien.<br/>
                  Zonder zichtbaarheid bestaat je expertise simpelweg niet in het netwerk.
                  <br/><br/>
                  <b>Autoriteit</b><br/>
                  Vervolgens moeten mensen je serieus nemen.<br/>
                  Niet omdat je veel post, maar omdat je laat zien dat je patronen ziet die anderen missen.
                  <br/><br/>
                  <b>Positionering</b><br/>
                  Uiteindelijk moet ook duidelijk zijn waarvoor mensen bij jou moeten zijn.<br/>
                  Anders blijf je een interessante stem.. maar geen logische keuze.
                  <br/><br/>
                  Veel LinkedIn-advies blijft hangen bij de eerste stap.
                  <br/><br/>
                  <i>Post vaker.</i><br/>
                  <i>Gebruik hooks.</i><br/>
                  <i>Optimaliseer bereik.</i>
                  <br/><br/>
                  Terwijl autoriteit meestal ontstaat in de tweede en derde laag.
                  <br/><br/>
                  Niet door meer te posten.<br/>
                  Maar door scherper te denken.
                </p>
              </div>
            </div>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black" style={{paddingBottom:"1em"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Strategische Analyse</h3>

                <p style={{fontWeight:"bold"}}>1. Van LinkedIn-tip naar denkmodel</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterkere thought leadership</p>

                <p style={{fontWeight:"bold"}}>2. Van loze activiteit naar perceptie</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer strategisch niveau</p>

                <p style={{fontWeight:"bold"}}>3. Van losse observatie naar eigen methodiek</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterkere expertstatus</p>

                <p style={{fontWeight:"bold"}}>4. Van oppervlakkige LinkedIn-content naar inzicht</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: breder intellectueel gewicht</p>

                <p style={{fontWeight:"bold"}}>5. Van promotie naar educatieve autoriteit</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer vertrouwen bij lezers</p>

              </div>
            </div>

            <h4 style={{textAlign:"center"}}>Post 3: Peter breekt een mythe.</h4>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black">
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Ghostin Style</h3>
                <p style={{marginBottom:"1em"}}>
                  Het meest gegeven LinkedIn-advies is ook het minst waardevolle:
                  <br/><br/>
                  <i>"Post vaker."</i>
                  <br/><br/>
                  Alsof autoriteit een kwestie van volume is.
                  <br/><br/>
                  In werkelijkheid gebeurt er iets anders.
                  <br/><br/>
                  Mensen bouwen zelden autoriteit op door vaker te praten.<br/>
                  Ze bouwen autoriteit op wanneer ze iets zeggen dat anderen nog niet hadden gezien.
                  <br/><br/>
                  Niet activiteit zorgt voor gewicht.<br/>
                  Interpretatie doet dat.
                  <br/><br/>
                  Dat is waarom sommige professionals jarenlang posten zonder dat hun positie verandert.
                  <br/><br/>
                  En waarom één scherpe observatie soms meer reputatie bouwt dan twintig berichten.
                  <br/><br/>
                  Zichtbaarheid helpt.
                  <br/><br/>
                  Maar autoriteit ontstaat pas wanneer mensen denken:
                  <br/><br/>
                  <i>"Dit perspectief had ik zelf nog niet zo gezien."</i>
                </p>
              </div>
            </div>
            <div className="col-2" style={{marginTop:"2em"}}>
              <div className="card more-rounded card-black" style={{paddingBottom:"1em"}}>
                <h3 style={{textAlign:"center", marginTop:"1em"}}>Strategische Analyse</h3>

                <p style={{fontWeight:"bold"}}>1. Geen algemeen advies, maar myth-busting</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterkere intellectuele positionering</p>

                <p style={{fontWeight:"bold"}}>2. Geen platformfocus, maar perceptiefocus</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: hoger strategisch niveau</p>

                <p style={{fontWeight:"bold"}}>3. Geen loze activiteit, maar interpretatie</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: sterkere thought leadership</p>

                <p style={{fontWeight:"bold"}}>4. Geen instructie, maar perspectief</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: meer impact</p>

                <p style={{fontWeight:"bold"}}>5. Geen promotie, maar reputatiebouw</p>
                <p style={{margin:"0 2em 1em"}}>Resultaat: subtiele maar sterke autoriteitsopbouw</p>

              </div>
            </div>

          </div>
        </div>

        <ContactIntro />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Portfolio.js